export default {
  title: 'Articole epuizate',
  sections: {
    settings: 'Setări',
  },
  fields: {
    has_sold_out_items_auto_reset: {
      options: {
        auto_reset: 'Articolele epuizate sunt marcate automat ca disponibile din nou la sfârșitul zilei.',
        manual_reset: 'Personalul trebuie să marcheze articolele ca disponibile după ce le-a marcat ca epuizate.',
      },
    },
  },
  buttons: {
    save: 'Salvează',
  },
  toasts: {
    failed_to_save_changes: 'Eroare la salvarea modificărilor',
    changes_got_saved: 'Modificările au fost salvate',
  },
};
